import { FilterGroup, FilterGroupEncoded } from "./FilterGroup";
export class PropertyFilter {
    constructor(enabledWhen, requiredWhen) {
        /**
         * If enabled, whether it is required
         */
        this.requiredWhen = null;
        this.enabledWhen = enabledWhen;
        this.requiredWhen = requiredWhen;
    }
    static createDefault() {
        return new PropertyFilter(new FilterGroup([]).encoded, new FilterGroup([]).encoded);
    }
    getString(definitions) {
        const decodedEnabledWhen = this.enabledWhen.decode(definitions);
        const decodedRequiredWhen = this.requiredWhen === null ? null : this.requiredWhen.decode(definitions);
        if (decodedEnabledWhen.filters.length == 0) {
            // Always enabled
            if (decodedRequiredWhen === null) {
                return "Stap kan worden overgeslagen";
            }
            if (decodedRequiredWhen.filters.length == 0) {
                return "Stap kan niet worden overgeslagen";
            }
            return "Stap kan niet worden overgeslagen als: " + decodedRequiredWhen.toString();
        }
        if (decodedRequiredWhen === null) {
            return "Ingeschakeld (kan altijd worden overgeslagen) als: " + decodedEnabledWhen.toString();
        }
        if (decodedRequiredWhen.filters.length == 0) {
            return "Ingeschakeld als: " + decodedEnabledWhen.toString();
        }
        return "Ingeschakeld als: " + decodedEnabledWhen + ", enkel verplicht invullen als: " + decodedRequiredWhen.toString();
    }
    encode(context) {
        return {
            enabledWhen: this.enabledWhen.encode(context),
            requiredWhen: this.requiredWhen === null ? null : this.requiredWhen.encode(context)
        };
    }
    static decode(data) {
        return new PropertyFilter(data.field("enabledWhen").decode(FilterGroupEncoded), data.field("requiredWhen").nullable(FilterGroupEncoded));
    }
}
//# sourceMappingURL=PropertyFilter.js.map